// sendInvoice_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["container"]
  send() {
    this.containerTarget.innerHTML = '<div class="loading-spinner-container"><div id="loading-spinner"></div></div>';
  }
}
